"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rcPagination = _interopRequireDefault(require("rc-pagination"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireWildcard(require("../Button"));
var _prev = _interopRequireDefault(require("./img/prev.svg"));
var _next = _interopRequireDefault(require("./img/next.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PREV_BUTTON = 'prev';
var NEXT_BUTTON = 'next';
var JUMP_BUTTONS = ['jump-prev', 'jump-next'];
var itemsRender = function itemsRender(activePage, page, type) {
  return R.call(R.cond([[R.equals(PREV_BUTTON), function () {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      icon: _prev.default,
      theme: _Button.THEMES.TRANSPARENT
    });
  }], [R.equals(NEXT_BUTTON), function () {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      icon: _next.default,
      theme: _Button.THEMES.TRANSPARENT
    });
  }], [R.includes(R.__, JUMP_BUTTONS), function () {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      theme: _Button.THEMES.TRANSPARENT
    }, " ... ");
  }], [R.T, function () {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      theme: activePage === page ? _Button.THEMES.PURPLE : _Button.THEMES.TRANSPARENT
    }, page);
  }]]), type);
};
var Pagination = function Pagination(_ref) {
  var page = _ref.page,
    totalCount = _ref.totalCount,
    showTotal = _ref.showTotal,
    perPage = _ref.perPage,
    className = _ref.className,
    controlClassName = _ref.controlClassName,
    onChange = _ref.onChange;
  var onPageChange = (0, _react.useCallback)(function (selectedPage) {
    if (onChange) {
      onChange(selectedPage);
    }
  }, [onChange]);
  var renderFunc = (0, _react.useMemo)(function () {
    return R.partial(itemsRender, [page]);
  }, [page]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement(_rcPagination.default, {
    current: page,
    itemRender: renderFunc,
    pageSize: perPage,
    showTotal: showTotal,
    total: totalCount,
    onChange: onPageChange,
    className: controlClassName
  }));
};
Pagination.propTypes = {
  page: _propTypes.default.number.isRequired,
  totalCount: _propTypes.default.number.isRequired,
  perPage: _propTypes.default.number,
  showTotal: _propTypes.default.func,
  controlClassName: _propTypes.default.string,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Pagination);